import React, { useRef, useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import api from "../../lib/api";

export const inp = "w-full px-4 py-3 rounded-2xl border border-brand-soft bg-white text-[15px] outline-none focus:border-brand-limeDark";

export const Field = ({ label, optional, error, help, children }) => (
  <label className="block">
    <span className="flex items-center gap-1.5 text-sm font-medium text-brand-greenDeep mb-1.5">{label}{optional && <span className="font-normal text-brand-green/50">(facultatif)</span>}
      {help && <span title={help} className="text-brand-green/40 cursor-help"><HelpCircle className="w-3.5 h-3.5" /></span>}
    </span>
    {children}
    {error && <span className="block mt-1 text-xs text-red-600" data-testid="field-error">{error}</span>}
  </label>
);

export const Later = ({ children, testid }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-t border-brand-soft pt-3">
      <button type="button" onClick={() => setOpen(!open)} className="flex items-center gap-1 text-sm text-brand-green/60 hover:text-brand-greenDeep" data-testid={testid}>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} /> Compléter plus tard
      </button>
      {open && <div className="mt-3 grid sm:grid-cols-2 gap-3">{children}</div>}
    </div>
  );
};

export const AddressInput = ({ value, onChange, onPick, error }) => {
  const [sug, setSug] = useState([]);
  const t = useRef(null);
  const change = (v) => {
    onChange(v);
    clearTimeout(t.current);
    if (v.trim().length < 3) { setSug([]); return; }
    t.current = setTimeout(() => api.get(`/geo/address-search?q=${encodeURIComponent(v)}`).then((r) => setSug(r.data || [])).catch(() => setSug([])), 300);
  };
  return (
    <div className="relative">
      <input value={value} onChange={(e) => change(e.target.value)} placeholder="Ex. : 12 rue des Lilas, Lyon" className={inp} autoComplete="off" data-testid="wiz-address" />
      {sug.length > 0 && (
        <div className="absolute z-10 mt-1 w-full bg-white border border-brand-soft rounded-2xl shadow-lg overflow-hidden" data-testid="wiz-address-sug">
          {sug.slice(0, 5).map((s, i) => (
            <button key={i} type="button" onClick={() => { onPick(s); setSug([]); }} className="block w-full text-left px-4 py-2.5 text-sm hover:bg-brand-softer" data-testid={`wiz-address-sug-${i}`}>{s.label}</button>
          ))}
        </div>
      )}
      {error && <span className="block mt-1 text-xs text-red-600">{error}</span>}
    </div>
  );
};
